import { render, staticRenderFns } from "./CustomerValidations.vue?vue&type=template&id=362f2429&scoped=true&lang=pug"
import script from "./CustomerValidations.vue?vue&type=script&lang=js"
export * from "./CustomerValidations.vue?vue&type=script&lang=js"
import style0 from "./CustomerValidations.vue?vue&type=style&index=0&id=362f2429&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362f2429",
  null
  
)

export default component.exports